import { maxBreakpoints, minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const BORDER_WIDTH = 4;

export const imageBase = css`
  border-radius: ${pxToRem(10)};
`;

export const imageWidth = {
  regular: css`
    ${mediaQuery(
      { max: maxBreakpoints.M },
      css`
        width: ${pxToRem(146 - BORDER_WIDTH)};
      `,
    )}

    ${mediaQuery(
      { min: minBreakpoints.M },
      css`
        width: ${pxToRem(216 - BORDER_WIDTH)};
      `,
    )}
  `,
};

export const image = {
  regular: css`
    ${imageBase}
    ${imageWidth['regular']}
    ${mediaQuery(
      { max: maxBreakpoints.M },
      css`
        height: ${pxToRem(144 - BORDER_WIDTH)};
      `,
    )}
    ${mediaQuery(
      { min: minBreakpoints.M },
      css`
        height: ${pxToRem(216 - BORDER_WIDTH)};
      `,
    )};
  `,
  auto: css`
    ${imageBase}
    width:100%;
    height: auto;
    aspect-ratio: 1/1;
  `,
};
